/**
 * 标准化时间
 */
export default function normalizeTime(time0: number | string): Date {
  return new Date(time0);
}
